import Modal from "@mui/material/Modal";
import { IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";
import { SessionExpired } from "./SessionTimeout";
import { useNavigate } from "react-router-dom";

const ErrorModal = (props) => {
  const navigate = useNavigate();
  if (props.errorMessage === "Not authorized")
    return (
      <SessionExpired
        logout={() => {
          navigate("/login");
          props.onClose();
        }}
      />
    );
  return (
    <Modal onClose={props.onClose} onClick={props.onClose} open={true}>
      <div className="error-modal-container">
        <IconButton onClick={props.onClose} className="close-icon" size="large">
          <Close />
        </IconButton>
        <h1>Something went wrong</h1>
        <h2>{props.error}</h2>
        <p>{props.errorMessage}</p>
      </div>
    </Modal>
  );
};

export default ErrorModal;
